// extracted by mini-css-extract-plugin
module.exports = {"heroCover":"hero-home-cover-module--heroCover--3lJew"};